import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import i18next from 'i18next';

type Props = {
  devName: string;
  state: Number;
};

const AlarmStateDiv: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  const label = ConvertState(props.state, props.devName, t);
  return <div>{label}</div>;
};

export const ConvertState = (state: Number, devName: string, trans: TFunction<'translation'>): string => {
  let label = '';
  if (state == 1) {
    label = devName == 'PLC' ? i18next.t('AlarmStateDiv.発生', '発生') : i18next.t('AlarmStateDiv.検出', '検出');
  } else {
    label = i18next.t('AlarmStateDiv.復帰', '復帰');
  }

  return label;
};

export default AlarmStateDiv;
